import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useEnv } from '@praxis/component-runtime-env'
import { Layout } from '@design-systems/canvas-ui'

import { sideNavConfig } from '../../config/sideNavConfig'
import useActiveNavTab from '../../hooks/useActiveNavTab'
import { isAuthorizedToPage } from '../../helpers/UtilityHelper'
import { closeNoAccessPopUp } from '../../store/auth/actions'
import { closeSideNav } from '../../store/layout/actionCreator'

const AHSideNavCanvas = ({ onClose }) => {
  const dispatch = useDispatch()
  const envConfig = useEnv() || {}

  const { auth = {}, headerReducer: { role = '' } = {} } = useSelector(
    (state) => state,
  )

  const activeId = useActiveNavTab()

  const isAuthorizedPageHandler = (itemId) => {
    const { memberOf = [] } = auth
    const { REACT_APP_ROLES_CONFIG = {} } = envConfig
    const member = role ? [role] : memberOf
    return isAuthorizedToPage(itemId, member, REACT_APP_ROLES_CONFIG)
  }

  /**
   * Build the Canvas 8 items array.
   * Re-computed only when the active route or auth changes.
   */
  const navItems = useMemo(
    () =>
      sideNavConfig
        .filter(({ id }) => isAuthorizedPageHandler(id))
        .map(({ id, label, icon, redirectionUrl }) => ({
          id,
          label,
          icon,
          isActive: activeId === id,
          as: Link,
          props: { to: redirectionUrl },
          onClick: () => {
            dispatch(closeNoAccessPopUp())
          },
        })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeId, auth, role],
  )

  const handleClose = () => {
    onClose?.()
    dispatch(closeSideNav())
  }

  return (
    /*
     * Wrapper div: position fixed, full height left rail.
     * Canvas 8's Layout.SideNav renders a <nav> with the primaryNav CSS class
     * (grid-area 3/1/span3/span1) but that only works inside Canvas 8's Layout
     * grid shell. Since we keep the existing MUI-based app shell, we position
     * the rail ourselves using CSS (see layout.css .ah-sidenav-rail).
     */
    <div className="ah-sidenav-rail" data-testid="ah-sidenav-rail">
      <Layout.SideNav
        items={navItems}
        isOpen
        onClose={handleClose}
        data-testid="ah-side-nav"
      />
    </div>
  )
}

AHSideNavCanvas.propTypes = {
  /** Called when the mobile close button is pressed */
  onClose: PropTypes.func,
}

export default AHSideNavCanvas
